<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="PurchaseRequisitionId"
      ref="list"
      unit="请购单"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="!is_listDialog && isShow"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      @row-select="showRow"
     :showTrendTable="isShow"
      urlHash="business/purchase/inquiry"
      :temp-params="tempParams"
      
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <!-- 明细 -->
    <el-button v-if="show" type="primary" @click="onCustomTable" icon="el-icon-s-tools" style="margin:30px 0 10px 0">
      明细项
    </el-button>
    <el-table 
      ref="multipleTable" :row-key="row => row.Prop" 
      :data="subList"  v-if="show"
      stripe border 
      @selection-change="handleSelectionChange"> 
      <el-table-column  v-if="is_listDialog" type="selection" width="55"> </el-table-column>
      <template v-for="(item,index) in tableColumns" >
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column 
            :resizable="false"
            :key="`${item.Prop}-${index}`" :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label" 
            :align="item.Align ?? 'left'" 
            :min-width="item.Width"
            show-overflow-tooltip
          >
          <template slot-scope="{row}">
            <span v-if="isNumericProperty(item.Prop)">
              {{ $commonJs.toThousands(row[item.Prop]) }}
            </span>
            <span v-else>
              {{ row[item.Prop] }}
            </span>
          </template>
        </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog ref="customTableDialog" @onSave="onSave" :initTableData='tableColumns' tableType='请购单明细'/>
    <!-- <el-table
      ref="multipleTable"
      class="subItem-table"
      :data="subList"
      tooltip-effect="dark"
      v-if="show"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column  v-if="is_listDialog" type="selection" width="55"> </el-table-column>
      <el-table-column
        align="left"
        prop="ProductNo"
        label="存货编码"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="ProductName"
        label="存货名称"
        min-width="120px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="left"
        prop="ProductSpec"
        label="规格"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="ColorName"
        label="颜色"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="UnitName"
        label="计量单位"
      ></el-table-column>
      <el-table-column
        align="right"
        prop="Quantity"
        label="数量"
      >
      <template slot-scope="{ row }">
        <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
      </template>
      </el-table-column>
      <el-table-column
        align="right"
        prop="Price"
        label="单价"
        v-if="canPrice"
      ></el-table-column>
      <el-table-column
        align="right"
        prop="Amount"
        label="金额"
        v-if="canPrice"
      >
      <template slot-scope="{ row }">
        <span>{{ $commonJs.toThousands(row.Amount) }}</span>
      </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

export default {
  mixins: [listMixin],
  components: { list,customTableDialog },
  data() {
    return {
      api: require("@/api/pu/puPredictOrder").default,
      FieldSettingApi: require("@/api/sy/fieldSetting").default,
      show: false,
      orderNo: "",
      subSelectList: [],
      subList: [],
      params: {
        RankName: "",
      },
      tempParams: {},
      tableColumns:[]
    };
  },
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
    is_listDialog: {
      typeof: Boolean,
      default: false,
    },
    TradeUnitId: {
      type: Number,
      default: null
    },
    isSelect: {
      typeof: Boolean,
      default: false,
    },
    // canPrice: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/purchase/inquiry");
    },
  },
  activated(){
    this.getRouterInfo()
  },
  mounted(){
    this.getTableColumns()
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false;
      const priceProps = [
        'PurchasePrice', 'SalePrice', 'RetailPrice', 'QuotedPrice', 
        'Discount', 'TaxRate', 'Price', 'TaxPrice', 'Amount', 
        'TaxLimit', 'TaxAmount', 'DiscountAmount'
      ];
      return (this.canPrice && priceProps.includes(item.Prop)) || !priceProps.includes(item.Prop);
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ['Quantity', 'Amount',].includes(prop);
    },
    async getTableColumns(){
      const res = await this.FieldSettingApi.list({Type: "请购单明细"})
      this.tableColumns = [] 
      this.tableColumns = res.Data
    },
    onCustomTable(){
      this.$refs.customTableDialog.dialogVisible = true
    },
    onSave(){
      this.getTableColumns()
      this.$message.success('保存成功')
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    getRouterInfo(){
      if(this.$router.history.current.params){
        this.tempParams.Ids= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.Ids
        };
        this.tempParams.SourceType= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceType
        };
        this.tempParams.SourceDocId= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceDocId
        };
        this.tempParams.SaOrderNo= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SaOrderNo
        };
        console.log(this.$router.history.current.params.SourceType,'this.$router.history.current.params.SourceType');
        this.$refs.list.getData()
      }    
    },
    // 选择报价明细
    handleSelectionChange(data) {
      this.subSelectList = data;
    },
    toggleSelection(rows) {
      let $multipleTable = this.$refs.multipleTable;
      if($multipleTable){
         if (rows) {
          rows.forEach(row => {
            $multipleTable.toggleRowSelection(row);
          });
        } else {
          $multipleTable.clearSelection();
        }
      }
    },
    clearSubSelectList(){
      this.toggleSelection()
    },
    clearList(){
      this.subSelectList = [];
      this.show = false;
    },
    showRow(data) {
      console.log('this.isSelect', this.isSelect)
      
      this.show = false;
      this.api.info({Id: data.OrderId, IsRemoveOccupy: this.isSelect}).then((res) => {
        if (res.Code === 0 && res.Data.length != 0) {
          this.show = true;
          this.orderNo = res.Data.OrderNo
          if(this.TradeUnitId != null){
            this.subList = res.Data.Products.filter(item => {
              return item.TradeUnitId === this.TradeUnitId
            })
          }else{
             this.subList = res.Data.Products;
          }

          if(this.isSelect){

            this.subList = this.subList.filter(item => {
              return item.Quantity !== 0;
            })
            
          }
         
        }
      });
      this.getTableColumns()
      // this.subList.push(data)
    },

    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
